module.exports = __webpack_public_path__ + "media/stylesheets/images/icon/profile_active-3bdc13a1404e1bd2ee9462b37e35e7ec.png";